export const createCard = `
    mutation createCard($input: CreateCardInput!) {
        createCard(input:$input) {
            id
            customerId
            last4
            expMonth
            expYear
            name
    }
}`;

export const updateCard = `
    mutation updateCard($input: UpdateCardInput!) {
        updateCard(input:$input){
            id
            customerId
            last4
            expMonth
            expYear
            name
        }
}`;

export const deleteCard = `
    mutation deleteCard($input: DeleteCardInput!) {
        deleteCard(input:$input)
}`;
